/* eslint no-debugger: "off" */
import { API } from '@utils/axios'

export async function fetchLiverVideoPointPerPeriodSettings () {
  const response = await API.get<TSettingManagement.TState['liverVideoPointPerPeriodSettings']>('/SettingManagement/GetLiverVideoPointByPeriodSetting')
  return response.data
}

export async function updateLiverVideoPointPerPeriodSettings (data: TSettingManagement.TState['liverVideoPointPerPeriodSettings']) {
  const response = await API.post('/SettingManagement/UpdateLiverVideoPointByPeriodSettings', data)
  return response.data
}
